import styled from 'styled-components'

import { tileAspectRatioPadding, tileMarginBottom } from '../../../../styles'

export const Container = styled.div`
  background: #e7e7e7;
  margin-bottom: ${tileMarginBottom};
  padding-bottom: ${tileAspectRatioPadding};
  position: relative;
`

export const TextWrap = styled.div`
  left: 13.5%;
  position: absolute;
  right: 13.5%;
  top: 50%;
  transform: translate(0, -50%);
`

export const Title = styled.h3`
  color: ${o => o.theme.color.deprecated.gray.dark};
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 2.4px;
  text-transform: uppercase;
`

export const Subtitle = styled.p`
  color: ${o => o.theme.color.deprecated.gray.medium};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.6px;
  margin-top: 16px;
`
